import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";
import { cn } from "@volca/ui/lib/utils";

interface RunSnapshotHeaderProps {
  badges: ReactNode;
  description: ReactNode;
  action?: { to: string; label: string };
  className?: string;
}

export const RunSnapshotHeader = ({
  badges,
  description,
  action,
  className,
}: RunSnapshotHeaderProps) => (
  <Stack
    direction="row"
    align="center"
    justify="between"
    gap={4}
    className={cn("w-full shrink-0 flex-wrap gap-y-2 border-b py-3", className)}
  >
    <Stack direction="row" align="center" gap={2} className="min-w-0 flex-wrap">
      {badges}
      <Text variant="caption" tone="muted">
        {description}
      </Text>
    </Stack>
    {action && (
      <Link
        to={action.to}
        className="shrink-0 text-sm font-medium text-link hover:underline"
      >
        {action.label}
      </Link>
    )}
  </Stack>
);
